import React from "react";

const defaultRiskOpportunityEffectsData = [
  {
    sno: 1,
    ro: "",
    currentEffects: "",
    anticipatedEffects: "",
    areaOfConcentration: "",
  },
];

const OpportunityEffectsTable = ({ opportunityData, setOpportunityData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...opportunityData];
    updated[index][field] = value;
    setOpportunityData(updated);
  };

  const renumberRows = (arr) => arr.map((r, i) => ({ ...r, sno: i + 1 }));

  const addRow = () =>
    setOpportunityData([
      ...opportunityData,
      {
        sno: (opportunityData?.length || 0) + 1,
        ro: "",
        currentEffects: "",
        anticipatedEffects: "",
        areaOfConcentration: "",
      },
    ]);

  const removeRow = () =>
    opportunityData.length > 1 &&
    setOpportunityData(renumberRows(opportunityData.slice(0, -1)));

  // ⬇⬇ CHANGED: removed per-cell border (outer border will be on the frame)
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const textAreaStyle = {
    ...inputStyle,
    minHeight: "70px",
    resize: "vertical",
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* ⬇⬇ NEW: table frame + CSS for perfect corners */}
      <style>{`
        .roTableFrame{
          border: 1px solid #000;
          border-radius: 8px;
          overflow: hidden;
        }
        .roTable{
          width: 100%;
          border-collapse: collapse;
        }
        .roTable th,
        .roTable td{
          border: 1px solid #000;      /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .roTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide the outer edges so the frame draws the outside border */
        .roTable thead tr:first-child th{ border-top: 0; }
        .roTable tr th:first-child,
        .roTable tr td:first-child{ border-left: 0; }
        .roTable tr th:last-child,
        .roTable tr td:last-child{ border-right: 0; }
        .roTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div className="roTableFrame">
        <table className="roTable">
          <thead>
            <tr>
              <th style={{ ...header, width: 70 }}>
                S.
                <br />
                NO.
              </th>
              <th style={header}>Risk/Opportunity</th>
              <th style={header}>
                Current Effects on
                <br />
                Business Model/Value Chain
              </th>
              <th style={header}>
                Anticipated
                <br />
                Future Effects
              </th>
              <th style={header}>
                Area of Concentration
                <br />
                <span style={{ fontStyle: "italic" }}>
                  (Geography, Facility,
                  <br />
                  Asset Type)
                </span>
              </th>
            </tr>
          </thead>

          <tbody>
            {opportunityData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{row.sno || index + 1}.</td>

                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.ro}
                    onChange={(e) => handleChange(index, "ro", e.target.value)}
                    style={inputStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.currentEffects}
                    onChange={(e) =>
                      handleChange(index, "currentEffects", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.anticipatedEffects}
                    onChange={(e) =>
                      handleChange(index, "anticipatedEffects", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.areaOfConcentration}
                    onChange={(e) =>
                      handleChange(index, "areaOfConcentration", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          gap: 10,
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default OpportunityEffectsTable;
